import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import TimeAddOn from "@coworker/apprestructured/src/task-management/components/LogsAndComments/TimeAddOn/TimeAddOn";
import styles from "./CommentsTab.module.css";
import { CommentImages } from "@coworker/apprestructured/src/task-management/components/CommentImages/CommentImages";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

type CommentsTabProps = {
  items: CommentsTabItem[];
};

export type CommentsTabItem = {
  title: string;
  content: string;
  time: string;
  imageUrls: string[] | Loading;
};

function CommentsTab({ items }: CommentsTabProps) {
  return (
    <FixaListView id="comments">
      {items.map(({ title, content, time, imageUrls }, i) => (
        <FixaListViewItem
          key={i}
          title={<span className={styles["title"]}>{title}</span>}
          description={
            <div className={styles["description"]}>
              {content.length > 0 ? content : null}
              <CommentImages urls={imageUrls} />
            </div>
          }
          addOn={<TimeAddOn>{time}</TimeAddOn>}
          emphasised
          inset
        />
      ))}
    </FixaListView>
  );
}

export default CommentsTab;
